// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-close {
  color: white;
  opacity: 1;
}

.lmar-mob0-desk12{
  margin-left: 12px;
}

.lpad-mob12-desk0{
  padding-left: 0px;
}



@media screen and (max-width: 999px) {
  .lmar-mob0-desk12{
    margin-left: 0px;
  }
  .lpad-mob12-desk0{
    padding-left: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modal/Modal.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;;;AAIA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".btn-close {\n  color: white;\n  opacity: 1;\n}\n\n.lmar-mob0-desk12{\n  margin-left: 12px;\n}\n\n.lpad-mob12-desk0{\n  padding-left: 0px;\n}\n\n\n\n@media screen and (max-width: 999px) {\n  .lmar-mob0-desk12{\n    margin-left: 0px;\n  }\n  .lpad-mob12-desk0{\n    padding-left: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
